import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import DashboardPage from "@/pages/DashboardPage";
import LeadsPage from "@/pages/LeadsPage";
import LeadDetailPage from "@/pages/LeadDetailPage";
import ContractTemplatesPage from "@/pages/ContractTemplatesPage";
import EmailTemplatesPage from "@/pages/EmailTemplatesPage";
import DripCampaignsPage from "@/pages/DripCampaignsPage";
import CampaignBuilderPage from "@/pages/CampaignBuilderPage";
import BuyersPage from "@/pages/BuyersPage";
import BuyerDetailPage from "@/pages/BuyerDetailPage";
import WholesalersPage from "@/pages/WholesalersPage";
import EarningsPage from "@/pages/EarningsPage";
import ProfilePage from "@/pages/ProfilePage";
import ApiKeysPage from "@/pages/ApiKeysPage";
import TasksPage from "@/pages/TasksPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <div className="h-8 w-8 border-2 border-sky-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <div className="h-8 w-8 border-2 border-sky-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><LeadsPage /></ProtectedRoute>} />
      <Route path="/leads/:id" element={<ProtectedRoute><LeadDetailPage /></ProtectedRoute>} />
      <Route path="/buyers" element={<ProtectedRoute><BuyersPage /></ProtectedRoute>} />
      <Route path="/buyers/:id" element={<ProtectedRoute><BuyerDetailPage /></ProtectedRoute>} />
      <Route path="/wholesalers" element={<ProtectedRoute><WholesalersPage /></ProtectedRoute>} />
      <Route path="/earnings" element={<ProtectedRoute><EarningsPage /></ProtectedRoute>} />
      <Route path="/templates" element={<ProtectedRoute><ContractTemplatesPage /></ProtectedRoute>} />
      <Route path="/email-templates" element={<ProtectedRoute><EmailTemplatesPage /></ProtectedRoute>} />
      <Route path="/drip-campaigns" element={<ProtectedRoute><DripCampaignsPage /></ProtectedRoute>} />
      <Route path="/drip-campaigns/:id/edit" element={<ProtectedRoute><CampaignBuilderPage /></ProtectedRoute>} />
      <Route path="/drip-campaigns/new" element={<ProtectedRoute><CampaignBuilderPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/tasks" element={<ProtectedRoute><TasksPage /></ProtectedRoute>} />
      <Route path="/integrations" element={<ProtectedRoute><ApiKeysPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
